module.exports = __webpack_public_path__ + "img/whss-logo.3f6eec98.png";